exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-container[data-v-5b856e5c]{display:flex;justify-content:center;align-items:center;height:100vh;background-color:#f5f7fa}.login-card[data-v-5b856e5c]{width:400px;box-shadow:0 2px 12px 0 rgba(0,0,0,.1)}.login-title[data-v-5b856e5c]{text-align:center;margin-bottom:30px;color:#303133}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5b856e5c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Login.vue
// module id = yJzD
// module chunks = 1